// @platform-only: React banner showing peer-recovery progress after a restore.
// Reads zustand state set by recoveryAnnounce.ts and threadService.ts; renders
// a non-blocking row with a dismiss button.

import React from "react";
import { X, Loader2 } from "lucide-react";
import { useStore } from "@/state/store/index";

export function RecoveryStatusBanner() {
  const active = useStore((s: any) => s.recoveryAnnounceActive);
  const count = useStore((s: any) => s.recoveryReshareCount);
  const dismiss = useStore((s: any) => s.dismissRecoveryAnnounceWindow);

  if (!active) return null;

  return (
    <div className="mx-3 mt-2 mb-1 flex items-center gap-3 rounded-lg border border-border bg-secondary/70 px-3 py-2 text-sm shadow-sm">
      <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />
      <div className="flex-1 leading-tight">
        <div className="font-medium">Recovering groups and communities</div>
        <div className="text-xs text-muted-foreground">
          {count} recovered from your contacts
        </div>
      </div>
      <button
        type="button"
        onClick={() => dismiss?.()}
        className="rounded p-1 text-muted-foreground hover:text-foreground"
        aria-label="Dismiss"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
